// extracted by mini-css-extract-plugin
module.exports = {"desktopWrapper":"header-skeleton_component_desktopWrapper__hB6KB","mobileWrapper":"header-skeleton_component_mobileWrapper__Qxpkx"};